module.exports = __webpack_public_path__ + "img/banner.5350b35e.jpg";